import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import {
  fetchMasterList,
  fetchMasterListById,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import ItemService from "../../../../services/commonService";
import { disableButtonForSeconds } from "../../../common/util";

const ChemicalForm = (props) => {
  let [edit, setEdit] = useState(false);
  let [deptCode, setDeptCode] = useState();
  let [deptName, setDeptName] = useState();
  let [machineCode, setMachineCode] = useState();
  let [machineName, setMachineName] = useState();
  let [machineError, setMachineError] = useState(false);
  let [machineValue, setMachineValue] = useState();

  const [validate, setValidate] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const buttonRef = useRef();
  const [error, setError] = useState(false);
  const [errorVal, setErrorVal] = useState(false);
  const [chemicalMaster, setChemicalMaster] = useState([]);
  // const [chemicalCode, setChemicalCode] = useState();
  // const [chemicalName, setChemicalName] = useState();
  // const [UOM, setUOM] = useState();
  // const [chemicalQuantity, setChemicalQuantity] = useState();
  const [values, setValues] = useState({});

  const handleInputChange = (id, newValue) => {
    if (/^\d*\.?\d*$/.test(newValue)) {
      setValues((prev) => ({
        ...prev,
        [id]: newValue,
      }));
    }
  };

  const handleInputChangeQCR = (id, newValue) => {
    setValues((prev) => ({
      ...prev,
      [id]: newValue,
    }));
  };

  useEffect(() => {
    if (props.data.machineCode) {
      setDeptCode(props?.data?.deptCode);
      setDeptName(props?.data?.deptName);
      setEdit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let deptList = useSelector(
    (state) => state?.masterList?.page[Constants.MASTER.DEPARTMENT.name]?.data,
  ); // User Details from Store
  useEffect(() => {
    if (!deptList) {
      dispatch(fetchMasterList(Constants.MASTER.DEPARTMENT));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deptList]);

  const deptResult =
    deptList &&
    deptList.map(({ deptCode, deptName }) => ({
      deptCode,
      deptName: `${deptCode} - ${deptName}`,
    }));

  const loadChemicalDetails = async (deptCode) => {
    let param = {
      deptCode,
    };
    await ItemService.getChemicalDetailsByDept(param).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setChemicalMaster(item.data);
      }
    });
  };

  const handleSave = (event) => {
    const form = formRef.current;
    if (!deptCode) {
      setError(true);
      return;
    }

    if ((deptCode === "DEPT010" || deptCode === "DEPT011") && !machineCode) {
      setMachineError(true);
      return;
    }

    const allChemicalsValid = chemicalMaster.every((chem) => {
      const value = values[chem.chemicalCode];
      const qcrNo = values[`qcrNo_${chem.chemicalCode}`];
      return value !== undefined && value !== "" && qcrNo !== undefined && qcrNo !== "";
    });
    if (!allChemicalsValid) {
      setErrorVal(true);
      return;
    }

    // To get the final array of entered chemicals (with their data):
    const enteredChemicals = chemicalMaster
      .filter(
        (chem) =>
          values[chem.chemicalCode] !== undefined &&
          values[chem.chemicalCode] !== "",
      )
      .map((chem) => ({
        chemicalCode: chem.chemicalCode,
        chemicalName: chem.chemicalName,
        uom: chem.uom,
        qcrNo: values["qcrNo_"+chem.chemicalCode] || "", // Get the QCR number for this chemical
        value: Number(values[chem.chemicalCode]),
      }));

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    } else {
      setValidate(false);
      const obj = {
        deptCode,
        deptName,
        machineCode,
        machineName,
        values: enteredChemicals,
      };
      if (edit) {
        obj._id = props.data._id;
      }
      props.onSave(obj, edit);
      setEdit(false);

      // Disable the button for 10 seconds
      if (buttonRef.current) {
        disableButtonForSeconds(buttonRef.current, 8);
      }
      // handleCancel();
    }
  };

  const handleCancel = (event) => {
    props.onHide();
  };

  const handleMachineByDept = (deptCode, deptName, clearInd = true) => {
    setDeptCode(deptCode);
    setDeptName(deptName);
    let param = {};
    param.url = "getMasterListDataById";
    param.page = Constants.MASTER.MACHINES.name;
    param.id = deptCode;
    dispatch(fetchMasterListById(param)).then((result) => {
      // console.log("machineResult",result)
      const machineResult =
        result?.payload?.data &&
        result?.payload?.data.map(({ machineCode, machineName }) => {
          return {
            machineCode,
            machineName,
          };
        });
      setMachineValue(machineResult);
      if (clearInd) {
        setMachineCode("");
        setMachineName("");
      }
    });
  };

  const { show, onHide } = props;
  return (
    <Modal
      show={show}
      onHide={onHide}
      animation={false}
      backdrop="static"
      dialogClassName="modal-70w"
    >
      <ModalHeader
        title={
          edit
            ? t("msg_master_list.msg_chemical.edit_page_title")
            : t("msg_master_list.msg_chemical.page_title")
        }
      ></ModalHeader>
      <ModalBody>
        <Form noValidate validated={validate} ref={formRef}>
          <Form.Group className="mb-3">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_chemical.select_department")}
            </Form.Label>
            <DropdownListField
              required
              id="deptCode"
              name="deptName"
              className="dropdownHive w-full rounded-md"
              data={deptResult}
              value={deptCode}
              onChange={(value) => {
                setDeptCode(value?.deptCode);
                setDeptName(value?.deptName);
                loadChemicalDetails(value?.deptCode);
                handleMachineByDept(value.deptCode, value.deptName);
                setError(false);
                setErrorVal(false);
              }}
              placeholder={t("msg_master_list.msg_chemical.select_department")}
              autoFocus={true}
              error={error}
              disabled={!deptResult}
            />
          </Form.Group>

          {(deptCode === "DEPT010" || deptCode === "DEPT011") && (
            <Form.Group className="mb-3">
              <Form.Label className="col-form-label">
                {t("msg_master_list.msg_chemical.machineName")}
              </Form.Label>
              <DropdownListField
                id="machineCode"
                name="machineCode"
                className="dropdownHive w-full rounded-md"
                data={machineValue}
                value={machineCode}
                required
                onChange={(value) => {
                  setMachineCode(value?.machineCode);
                  setMachineName(value?.machineName);
                  setMachineError(false);
                }}
                placeholder={t("msg_master_list.msg_checklist.select_machines")}
                autoFocus={false}
                error={machineError}
                disabled={!machineValue}
              />
            </Form.Group>
          )}

          {chemicalMaster.length !== 0 && (
            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label className="col-form-label">
                {t("msg_master_list.msg_chemical.code")}* :
                {chemicalMaster.map((item) => (
                  <Row
                    className="mb-3"
                    key={item._id}
                    style={{ alignItems: "center" }}
                  >
                    <Col
                      xs={4}
                      className="commLeftRightPadding bg-table-status bg-table-documentNumber-status mt-4"
                    >
                      <Form.Label className="pt-2 text-white">
                        {item.chemicalCode} - {item.chemicalName}
                      </Form.Label>
                    </Col>
                    <Col xs={3} className="commLeftRightPadding mt-4">
                      <Form.Control
                        type="text"
                        placeholder="Enter value"
                        value={values[item.chemicalCode] || ""}
                        onChange={(e) =>
                          handleInputChange(item.chemicalCode, e.target.value)
                        }
                      />
                    </Col>
                    <Col xs={2} className="commLeftRightPadding mt-4">
                      <Form.Control type="text" value={item.uom} disabled />
                    </Col>
                    <Col xs={3} className="commLeftRightPadding">
                      {t("msg_master_list.msg_chemical.QCR_NO")}*
                      <Form.Control
                        type="text"
                        placeholder="Enter QCR Number"
                        id="qcrNo"
                        name="qcrNo"
                        value={values["qcrNo_"+item.chemicalCode] || ""}
                        onChange={(e) =>
                          handleInputChangeQCR("qcrNo_"+item.chemicalCode, e.target.value)
                        }
                        required
                        error={errorVal}
                      />
                    </Col>
                  </Row>
                ))}
              </Form.Label>
            </Form.Group>
          )}

          {errorVal && (
            <p className="errorMsg float-right">
              {"Please Enter Mandatory Fields and Values for all Chemicals."}
            </p>
          )}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          ref={buttonRef}
          type="button"
          variant="success"
          className="btn btn-success"
          onClick={handleSave}
        >
          {t("msg_common.save")}
        </Button>
        <Button
          type="button"
          variant="danger"
          className="btn btn-danger"
          onClick={handleCancel}
          data-dismiss="modal"
        >
          {t("msg_common.cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ChemicalForm;
